import axiosClient from "./axiosClient";

const paymentApi = {
    getAll(query?: string) {
        const baseURL = `/payment?${query || ""}`;
        return axiosClient.get(baseURL);
    },
    // Xuất CSV toàn bộ yêu cầu rút tiền / thanh toán theo bộ lọc đang xem.
    exportCsv(query?: string) {
        return axiosClient.get(`/payment/export?${query || ""}`, { responseType: "blob" });
    },
    // Báo cáo rút tiền theo tháng (khai thuế): đã chuyển khoản, gom theo ngày xử lý.
    getMonthlyReport(params: { from: string; to: string }) {
        return axiosClient.get(`/payment/monthly-report?${new URLSearchParams(params)}`);
    },
    exportMonthlyReport(params: { from: string; to: string; type: "summary" | "detail" }) {
        return axiosClient.get(`/payment/monthly-report/export?${new URLSearchParams(params)}`, {
            responseType: "blob",
        });
    },
    completePayment(id: number, data: FormData) {
        const baseURL = `/payment/complete/${id}`;
        return axiosClient.post(baseURL, data, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        });
    },
    // Hạn mức rút tiền (tối thiểu / tối đa mỗi lệnh) — lưu bảng Settings
    getWithdrawLimits() {
        return axiosClient.get("/payment/withdraw-limits/config");
    },
    updateWithdrawLimits(data: { minAmount: number; maxAmount: number }) {
        return axiosClient.put("/payment/withdraw-limits/config", data);
    },
    cancellPayment(id: number, data: { note: string }) {
        const baseURL = `/payment/cancell/${id}`;
        return axiosClient.put(baseURL, data);
    },
};

export default paymentApi;
